import { render, staticRenderFns } from "./ChooseTokenList.vue?vue&type=template&id=2acc0116"
import script from "./ChooseTokenList.vue?vue&type=script&lang=js"
export * from "./ChooseTokenList.vue?vue&type=script&lang=js"
import style0 from "./ChooseTokenList.vue?vue&type=style&index=0&id=2acc0116&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports